module.exports = __webpack_public_path__ + "img/MusicNow.e71b5148.svg";